module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQAAAAB/ecQqAAAAAnRSTlMAAHaTzTgAAAAWSURBVHgBY6AFYP4PBAewUoPbFMoBAE11OPW6yVcZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Actionbar/ic_menu_white_24dp_2x.png
// module id = 56
// module chunks = 0